import type { StyleRule } from '@archipro-design/aria';
import {
    HeaderClassName,
    pxArrayToRem,
    pxToRem,
    swipeableEdgeClassName,
    swipeableEdgeSlotClassNames,
} from '@archipro-design/aria';

export const ContentContainer: StyleRule = ({ theme: { screen } }) => ({
    width: '100%',
    height: '100%',
    position: 'relative',
    padding: pxArrayToRem([14, 0, 0, 0]),
    overflow: 'hidden',

    [screen.min.tablet]: {
        width: pxToRem(532),
        padding: pxArrayToRem([42, 32, 0, 30]),
    },
});

export const CloseButton: StyleRule = ({ theme: { screen } }) => ({
    display: 'none',
    [screen.min.tablet]: {
        display: 'inherit',
        position: 'absolute',
        top: 0,
        right: 0,
        padding: pxArrayToRem([20, 21]),
    },
});

export const TileContainer: StyleRule = ({ theme }) => ({
    display: 'none',
    [theme.screen.min.tablet]: {
        display: 'flex',
        padding: pxArrayToRem([0, 10]),
        marginBottom: pxToRem(62),
        '& > .variant-pricing': {
            paddingTop: pxToRem(15),
            '& > .subtitle': {
                display: 'none',
            },

            '& > .price-group': {
                display: 'flex',
                columnGap: pxToRem(5),
                '& > .price-prefix': {
                    ...theme.siteVariables.textStyles.Text.Roman55,
                    color: '#717171',
                    display: 'flex',
                    width: 'fit-content',
                    fontSize: pxToRem(16),
                    lineHeight: pxToRem(16),
                    letterSpacing: 0,
                },

                '& > .retail-price': {
                    ...theme.siteVariables.textStyles.Text.Roman55,
                    color: theme.siteVariables.colors.grey[100],
                    display: 'flex',
                    width: 'fit-content',
                    fontSize: pxToRem(16),
                    lineHeight: pxToRem(16),
                    letterSpacing: 0,
                },

                '& > .price': {
                    ...theme.siteVariables.textStyles.Text.Roman55,
                    color: '#717171',
                    display: 'flex',
                    width: 'fit-content',
                    fontSize: pxToRem(16),
                    lineHeight: pxToRem(16),
                    letterSpacing: 0,
                },
            },
        },
    },
});

export const ProfessionalTitle: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(21),
    ...theme.siteVariables.textStyles.Text.Medium65,
    letterSpacing: '-0.01em',
});

export const ProductTitle: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(4),
    ...theme.siteVariables.textStyles.Text.Roman55,
    color: '#717171',
});

export const ProductPrice: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(15),
    ...theme.siteVariables.textStyles.Text.Roman55,
    color: '#717171',
});

export const LocationContainer: StyleRule = () => ({
    flex: 1,
    overflow: 'hidden',
});

export const LocationTitle: StyleRule = ({ theme }) => ({
    display: 'none',
    [theme.screen.min.tablet]: {
        display: 'flex',
        padding: pxArrayToRem([0, 10]),
        ...theme.siteVariables.textStyles.GTAmericaTrialFont.Bold75,
        textTransform: 'uppercase',
        maxWidth: pxToRem(354),
    },
});

export const LocationList: StyleRule = ({ theme }) => ({
    flex: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    [theme.screen.min.tablet]: {
        marginTop: pxToRem(34),
    },
});

export const MobileDrawer: StyleRule = () => ({
    [`& .${swipeableEdgeClassName}`]: {
        [`& .${swipeableEdgeSlotClassNames.puller}`]: {
            paddingBottom: pxToRem(25),
        },
    },
    [`& .${HeaderClassName}`]: {
        lineHeight: pxToRem(16),
        fontSize: pxToRem(16),
        letterSpacing: 0,
    },
});
